export const GET_ALL_APPLICATIONS = "GET_ALL_APPLICATIONS";
export const GET_ALL_APPLICATIONS_SUCCESS = "GET_ALL_APPLICATIONS_SUCCESS";
export const GET_ALL_APPLICATIONS_FAILURE = "GET_ALL_APPLICATIONS_FAILURE";

export const GET_APPLICATION = "GET_APPLICATION";
export const GET_APPLICATION_SUCCESS = "GET_APPLICATION_SUCCESS";
export const GET_APPLICATION_FAILURE = "GET_APPLICATION_FAILURE";

export const ADD_APPLICATION = "ADD_APPLICATION";
export const ADD_APPLICATION_SUCCESS = "ADD_APPLICATION_SUCCESS";
export const ADD_APPLICATION_FAILURE = "ADD_APPLICATION_FAILURE";

export const EDIT_APPLICATION = "EDIT_APPLICATION";
export const EDIT_APPLICATION_SUCCESS = "EDIT_APPLICATION_SUCCESS";
export const EDIT_APPLICATION_FAILURE = "EDIT_APPLICATION_FAILURE";

export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const DELETE_APPLICATION_SUCCESS = "DELETE_APPLICATION_SUCCESS";
export const DELETE_APPLICATION_FAILURE = "DELETE_APPLICATION_FAILURE";

export const REFRESH_CLIENT_TOKEN = "REFRESH_CLIENT_TOKEN";
export const REFRESH_CLIENT_TOKEN_SUCCESS = "REFRESH_CLIENT_TOKEN_SUCCESS";
export const REFRESH_CLIENT_TOKEN_FAILURE = "REFRESH_CLIENT_TOKEN_FAILURE";
